// ==============================|| OVERRIDES - TAB ||============================== //

export default function FormControl(theme) {
  return {
    MuiFormControl: {
      styleOverrides: {
        root: {
          '& .Mui-required .MuiFormLabel-asterisk': {
            color: theme.palette.error.main,
            fontWeight: 700
          }
        }
      }
    }
  };
}
